import { render, staticRenderFns } from "./promoters.vue?vue&type=template&id=65c4a827&scoped=true&"
import script from "./promoters.vue?vue&type=script&lang=js&"
export * from "./promoters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4a827",
  null
  
)

export default component.exports